import { Group, Stack, Text, Tooltip } from '@mantine/core'
import { cloneElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { VlmAction } from '@/types/vlm'
import { ACTION_TYPE_CONFIG, MILESTONE_STATE_CONFIG } from './vlmPipelineConfig'

type PipelineActionListProps = {
  actions: VlmAction[]
}

export const PipelineActionList = ({ actions }: PipelineActionListProps) => {
  if (actions.length === 0) {
    return (
      <Text size="xs" c="dimmed">
        <FormattedMessage id="vlm.pipelines.actionList.empty" />
      </Text>
    )
  }

  return (
    <Group gap="md" wrap="wrap">
      {actions.map((action, index) => {
        if (action.type === 'milestone') {
          return (
            <Group key={index} gap={6} wrap="nowrap" align="center">
              {MILESTONE_STATE_CONFIG.map(
                ({ key: stateKey, icon: stateIcon }) => {
                  const { name, level } = action.states[stateKey]

                  return (
                    <Tooltip
                      key={stateKey}
                      label={
                        <Text size="xs">{`${name} (${level ?? '—'})`}</Text>
                      }
                    >
                      {cloneElement(stateIcon, { size: 16 })}
                    </Tooltip>
                  )
                }
              )}
            </Group>
          )
        }

        const { icon } = ACTION_TYPE_CONFIG[action.type]

        return (
          <Tooltip
            key={index}
            disabled={action.recipients.length === 0}
            label={
              <Stack gap={2}>
                {action.recipients.map((recipient) => (
                  <Text key={recipient} size="xs">
                    {recipient}
                  </Text>
                ))}
              </Stack>
            }
          >
            <Group gap={6} wrap="nowrap" align="center">
              {cloneElement(icon, { size: 16 })}

              <Text size="xs" c="dimmed">
                ({action.recipients.length})
              </Text>
            </Group>
          </Tooltip>
        )
      })}
    </Group>
  )
}
